import React from 'react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from './ui/accordion';
import { FAQS, CONTACT } from '../mock';
import Reveal from './Reveal';
import { Phone } from 'lucide-react';

export default function FAQ() {
  return (
    <section id="faq" className="py-20 lg:py-28">
      <div className="max-w-4xl mx-auto px-5 lg:px-8">
        <Reveal>
          <div className="text-center max-w-2xl mx-auto mb-12">
            <span className="text-[13px] tracking-[0.3em] uppercase text-[#C4715A] font-medium">Good to Know</span>
            <h2 className="font-serif-display text-[36px] sm:text-[46px] text-[#26302a] mt-3 leading-tight">Frequently asked questions</h2>
          </div>
        </Reveal>

        <Reveal delay={80}>
          <Accordion type="single" collapsible className="space-y-3">
            {FAQS.map((f, i) => (
              <AccordionItem key={i} value={`item-${i}`} className="bg-white rounded-2xl border border-[#EFE8DD] px-5 overflow-hidden">
                <AccordionTrigger className="text-left font-serif-display text-[18px] text-[#2A2A28] hover:no-underline py-5">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-[15px] leading-relaxed text-[#5A554C] pb-5">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>

        <Reveal delay={120}>
          <div className="mt-10 text-center bg-[#F1ECE3] rounded-2xl p-8">
            <p className="text-[16px] text-[#4A4A45]">Still have a question? We are happy to help.</p>
            <a href={CONTACT.phoneHref} className="mt-4 inline-flex items-center gap-2 rounded-full bg-[#C4715A] hover:bg-[#a95a45] text-white text-[15px] font-medium px-6 py-3 transition-colors">
              <Phone className="w-4 h-4" /> Call {CONTACT.phone}
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
